// extracted by mini-css-extract-plugin
export default {"advertCardPhoto":"c-a_hg","advertCardPhoto__image":"c-a_hh"};